// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Zk4Tk","header":"ReportDetails_header__16qNJ","title":"ReportDetails_title__3rEpj","left":"ReportDetails_left__3dKxR"};